import { render, staticRenderFns } from "./DepartmentFilter.vue?vue&type=template&id=1c742ba7&scoped=true&"
import script from "./DepartmentFilter.vue?vue&type=script&lang=ts&"
export * from "./DepartmentFilter.vue?vue&type=script&lang=ts&"
import style0 from "./DepartmentFilter.vue?vue&type=style&index=0&id=1c742ba7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c742ba7",
  null
  
)

export default component.exports